export enum ChatMessageBlockType {
  RULE_BASED_AUTO_ASSIGN = 'rule_based_auto_assign',
  BASIC_AUTO_ASSIGN = 'basic_auto_assign',
  FLOW_BASED_ASSIGN = 'flow_based_assign',
  TAG_ADDED = 'tag_added',
  TAG_REMOVED = 'tag_removed',
  SEQ_ADDED = 'seq_added',
  SEQ_REMOVED = 'seq_removed',
  SEQ_PAUSED = 'seq_paused',
  SEQ_PAUSED_TEMPORARILY = 'seq_paused_temporarily',
  SEQ_RESUME = 'seq_resume',
  WIDGET_ADDED = 'widget_added',
  USER_CUF_SET = 'user_cuf_set',
  USER_CUF_UNSET = 'user_cuf_unset',
  USER_SUF_PHONE_CHANGE = 'user_suf_phone_change',
  USER_SUF_EMAIL_CHANGE = 'user_suf_email_change',
  USER_SUF_FIRST_NAME_CHANGE = 'user_suf_first_name_change',
  USER_SUF_LAST_NAME_CHANGE = 'user_suf_last_name_change',
  CLICK_BUY = 'click_buy',
  USER_ORDER_PAID = 'user_order_paid',
  USER_RULE_TRIGGERED = 'user_rule_triggered',
  USER_SMART_DELAY_SCHEDULED = 'user_smart_delay_scheduled',
  USER_SUBSCRIBED = 'user_subscribed',
  USER_UNSUBSCRIBED = 'user_unsubscribed',
  USER_FB_UNSUBSCRIBED = 'user_fb_unsubscribed',
  USER_IG_UNSUBSCRIBED = 'user_ig_unsubscribed',
  USER_WA_UNSUBSCRIBED = 'user_wa_unsubscribed',
  USER_SMS_UNSUBSCRIBED = 'user_sms_unsubscribed',
  USER_TG_UNSUBSCRIBED = 'user_tg_unsubscribed',
  USER_TT_SUBSCRIBED = 'user_tt_subscribed',
  USER_TT_UNSUBSCRIBED = 'user_tt_unsubscribed',
  TIKTOK_AD_REFERRAL = 'tt_ad_ref',
  FB_TIKTOK_ADS_REFERRAL = 'fb_tiktok_ads_referral',
  WA_TIKTOK_ADS_REFERRAL = 'wa_tiktok_ads_referral',
  TIKTOK_USERNAME_CHANGED = 'tiktok_username_changed',
  TIKTOK_DISPLAY_NAME_CHANGED = 'tiktok_display_name_changed',
  TT_UNSUPPORTED = 'tt_unsupported',
  SHARE_POST = 'share_post',
  USER_SEQUENCE_MESSAGE_SCHEDULED = 'user_sequence_message_scheduled',
  USER_SEQUENCE_MESSAGE_RESCHEDULED = 'user_sequence_message_rescheduled',
  FLOW_SEND_FROM_LC = 'flow_send_from_lc',
  MSGOUT_EMAIL = 'msgout_email',
  MSGOUT_KEYWORD_SMS = 'msgout_keyword_sms',
  MSGOUT_SMS = 'msgout_sms',
  CUSTOM_EVENT_TRIGGERED = 'custom_event_triggered',
  MSGOUT_MMS = 'msgout_mms',
  NOTIFY_ADMIN_LC = 'notify_admin_lc',
  FACEBOOK_GUEST_CHAT_STARTED = 'facebook_guest_chat_started',
  FACEBOOK_GUEST_CHAT_ENDED = 'facebook_guest_chat_ended',
  CGT_TRIGGER_COMMENT = 'cgt_trigger_comment',
  IG_CGT_TRIGGER_COMMENT = 'ig_cgt_trigger_comment',
  FOLLOW_REPLY_IG_FOLLOWED = 'follow_reply_ig_followed',
  USER_MERGED = 'user_merged',
  ASSIGN = 'assign',
  REASSIGN = 'reassign',
  UNASSIGN = 'unassign',
  USER_THREAD_NEW = 'user_thread_new',
  USER_THREAD_CLOSED = 'user_thread_closed',
  USER_THREAD_OPENED = 'user_thread_opened',
  AI_INTENT_TRIGGER_INSTAGRAM = 'ai_intent_trigger_instagram',
  AI_INTENT_TRIGGER_WHATSAPP = 'ai_intent_trigger_whatsapp',
  AI_INTENT_TRIGGER_FACEBOOK = 'ai_intent_trigger_facebook',
  AI_INTENT_TRIGGER_TIKTOK = 'ai_intent_trigger_tiktok',
  AI_INTENT_TRIGGER_TELEGRAM = 'ai_intent_trigger_telegram',
  TIKTOK_CTX_TRIGGER = 'tiktok_ctx_trigger',
  TT_URL_REF = 'tt_url_ref',

  WA_UNSUPPORTED = 'wa_unsupported',
  WA_REQUEST_WELCOME = 'request_welcome_whatsapp',
  RECURRING_NOTIFICATION_TOKEN_STOPPED = 'recurring_notification_token_stopped',
  IG_RECURRING_NOTIFICATION_TOKEN_STOPPED = 'ig_recurring_notification_token_stopped',
  RECURRING_NOTIFICATION_TOKEN_RESUMED = 'recurring_notification_token_resumed',
  IG_RECURRING_NOTIFICATION_TOKEN_RESUMED = 'ig_recurring_notification_token_resumed',
  SCHEDULED_MESSAGE_WAS_NOT_SENT = 'scheduled_message_was_not_sent',

  // these block types are possible only for deleted messages
  // because model is just { is_deleted: true } and there is no inner type in model
  // type is taken from original message
  // after all these types are mapped to INSTAGRAM_DELETED and INSTAGRAM_DELETED_OUT
  MSGIN_INSTAGRAM = 'msgin_instagram',
  MSGOUT_INSTAGRAM = 'msgout_instagram',
  MSGOUT_LC_INSTAGRAM = 'msgout_lc_instagram',
  MSGOUT_ECHO_INSTAGRAM = 'msgout_echo_instagram', // message from instagram page to customer

  // inner messages
  TEXT = 'text',
  ATTACHMENT = 'attachment',
  IMAGE = 'image',
  REMOTE_IMAGE = 'remote_image',
  GIF = 'gif',
  AUDIO = 'audio',
  VOICE = 'voice',
  VIDEO = 'video',
  FILE = 'file',
  SMS = 'sms',
  MMS = 'mms',
  QUESTION = 'question',
  OTN_REQUEST = 'otn_request', // one time notification
  CLICK_ACTION = 'click_action',
  CLICK_URL = 'click_url',
  STICKER = 'sticker',
  VIDEO_NOTE = 'video_note', // tg recorded videos
  LOCATION = 'location',
  MC_LOCATION = 'mc_location',
  PRODUCTS = 'products',
  CARDS = 'cards',
  CARD = 'card',
  CONTEXT_CARDS = 'context_cards',
  LIST = 'list',
  GUEST_LINK = 'guest_link',
  VISITOR_LINKED = 'visitor_linked',
  FALLBACK = 'fallback',
  RECEIPT = 'receipt',
  INSTAGRAM_DELETED = 'instagram_deleted', // created on frontend for deleted message by customer
  INSTAGRAM_DELETED_OUT = 'instagram_deleted_out', // created on frontend for deleted message by you
  STORY_REPLY_TO = 'story_reply_to',
  STORY_MENTION = 'story_mention',
  SHARE = 'share',
  UNSUPPORTED = 'unsupported',
  TEMPLATE = 'template', // whatsapp templates
  WA_LIST_MESSAGE = 'wa_list_message',
  WA_CATALOG_MESSAGE = 'wa_catalog_message',
  PRODUCT = 'product', // wa single product message
  CART = 'cart', // wa catalog cart
  REEL = 'reel', // fb reels

  // tiktok ads integration
  FB_TIKTOK_ADS_EVENT_SENT = 'fb_tiktok_ads_event_sent',
  WA_TIKTOK_ADS_EVENT_SENT = 'wa_tiktok_ads_event_sent',
  TIKTOK_ADS_CTX_TRIGGER_FB = 'tiktok_ads_ctx_trigger_fb',
  TIKTOK_ADS_CTX_TRIGGER_WA = 'tiktok_ads_ctx_trigger_wa',

  // AI Always-on Automation
  AI_AUTOMATION_INSTAGRAM_TRIGGERED = 'ai_automation_instagram_triggered',
  AI_AUTOMATION_INSTAGRAM_FINISHED = 'ai_automation_instagram_finished',
}
